import React, {Dispatch, FC, SetStateAction} from "react";
import {LearnCategory} from "../../../../lib/src/api/repositories/learn-repository";
import {BulkMoveToCategoryModal} from "../../modals/Bulk/BulkMoveToCategoryModal";
import {BulkDeleteLearnCategoryModal} from "../../modals/Bulk/BulkDeleteLearnCategoryModal";
import {BulkPinLearnCategoryModal} from "../../modals/Bulk/BulkPinLearnCategoryModal";
import {BulkUnpinLearnCategoryModal} from "../../modals/Bulk/BulkUnPinLearnCategoryModal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faThumbtack, faTrash} from "@fortawesome/free-solid-svg-icons";
import {faArrowRightArrowLeft, faThumbtackSlash} from "@fortawesome/pro-solid-svg-icons";
import {useModal} from "@jane/lib/src/components/layout/ModalProvider";

export const CategoryContextMenu: FC<{ selected: string[], setSelected: Dispatch<SetStateAction<string[]>>, categories: LearnCategory[], open: boolean, setOpen: Dispatch<SetStateAction<boolean>>, reload: () => void}> = (props) => {
  const { open: bulkMoveToCategoryModal } = useModal({title: "Categorieën verplaatsen", body: <BulkMoveToCategoryModal selected={props.selected} categories={props.categories} reload={props.reload} />, size: "xl"})
  const {open: bulkDeleteCategoryModal} = useModal({title: 'Archiveer categorieën', body: <BulkDeleteLearnCategoryModal selected={props.selected} reload={props.reload} />, size: 'md'})
  const {open: bulkPinCategoryModal} = useModal({title: 'Categorieën vastmaken', body: <BulkPinLearnCategoryModal selected={props.selected} reload={props.reload} />, size: 'md'})
  const {open: bulkUnpinCategoryModal} = useModal({title: 'Categorieën losmaken', body: <BulkUnpinLearnCategoryModal selected={props.selected} reload={props.reload} />, size: 'md'})
  return <>
    {props.open && <>
      <div className={'bg-[#0001] fixed inset-0 z-10'} onClick={() => props.setOpen(false)}></div>
      <div className={'absolute z-10 border border-slate-100 rounded-sm shadow-lg top-8 right-0 bg-white flex flex-col items-stretch'}>
        <button className={'px-4 py-2 flex items-center hover:bg-slate-50 font-medium'} onClick={() => {
          bulkPinCategoryModal()
          props.setOpen(false)
          props.setSelected([])
        }}>
          <div className={'h-8 w-8 flex items-center justify-center'}>
            <FontAwesomeIcon icon={faThumbtack} className={'text-brand-primary'} />
          </div>
          <div className={'whitespace-nowrap'}>Alles vastzetten</div>
        </button>
        <button className={'px-4 py-2 flex items-center hover:bg-slate-50 font-medium'} onClick={() => {
          bulkUnpinCategoryModal()
          props.setOpen(false)
          props.setSelected([])
        }}>
          <div className={'h-8 w-8 flex items-center justify-center'}>
            <FontAwesomeIcon icon={faThumbtackSlash} className={'text-brand-primary'} />
          </div>
          <div className={'whitespace-nowrap'}>Alles losmaken</div>
        </button>
        <button className={'px-4 py-2 flex items-center hover:bg-slate-50 font-medium'} onClick={() => {
          bulkMoveToCategoryModal()
          props.setOpen(false)
          props.setSelected([])
        }}>
          <div className={'h-8 w-8 flex items-center justify-center'}>
            <FontAwesomeIcon icon={faArrowRightArrowLeft} className={'text-brand-primary'} />
          </div>
          <div className={'whitespace-nowrap'}>Verplaatsen</div>
        </button>
        <button className={'px-4 py-2 flex items-center hover:bg-slate-50 font-medium'} onClick={() => {
          bulkDeleteCategoryModal()
          props.setOpen(false)
          props.setSelected([])
        }}>
          <div className={'h-8 w-8 flex items-center justify-center'}>
            <FontAwesomeIcon icon={faTrash} className={'text-brand-primary'} />
          </div>
          <div className={'whitespace-nowrap'}>Verwijderen</div>
        </button>
      </div>
    </>}
  </>
}